<router-outlet></router-outlet>
<div (click)="scrollToTop()" class="scroll-to-top" *ngIf="pageYoffset > 500">
  <mat-icon>keyboard_arrow_up</mat-icon>
</div>
<hun-footer *ngIf="(isWeb | async) && isPageWithFooter()"></hun-footer>
<div *ngIf="appInitializeService.appInitializing$ | async" class="disabled-overlay">
  <mat-spinner [diameter]="60" color="primary"></mat-spinner>
</div>
